// /frontend/src/services/categoryService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/categories`;

export const categoryService = {
  // Get all categories
  getCategories: async () => {
    try {
      const response = await apiClient.get(API_URL);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Get category by ID
  getCategoryById: async (id) => {
    try {
      const response = await apiClient.get(`${API_URL}/${id}`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await apiClient.post(API_URL, categoryData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Update category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await apiClient.put(`${API_URL}/${id}`, categoryData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await apiClient.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  }
};